import { z } from "zod";

export const serverResponse = z.object({ id: z.string() });
